export default {"src":"/_next/static/media/wifi.cb643a71.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};